/**
 * TESTING PHASE AGENTS CONFIG
 *
 * Add agent names here (must match the manifest name exactly, case-sensitive)
 * to show a "testing phase" ribbon on the AgentWelcome screen in production.
 *
 * The ribbon is purely informational — it warns users that the agent is under
 * a testing phase and should only be used by authorised personnel.
 *
 * Example:
 *   { agentName: 'My Agent' }
 *   { agentName: 'My Agent', message: 'Custom warning text for this agent.' }
 */

export interface TestingPhaseAgentConfig {
  /** Agent name as it appears in the manifest (case-sensitive). */
  agentName: string;
  /**
   * Optional custom ribbon message.
   * Falls back to the default message when not set.
   */
  message?: string;
}

export const DEFAULT_TESTING_MESSAGE =
  'This agent is currently in a testing phase and should only be used by authorised users.';

export const testingPhaseAgents: TestingPhaseAgentConfig[] = [
  { agentName: 'VendyBot' }
];

/** Returns true if the given agent name is marked as a testing-phase agent. */
export const isTestingPhaseAgent = (agentName: string): boolean =>
  testingPhaseAgents.some((a) => a.agentName === agentName);

/** Returns the config entry for a testing-phase agent, or undefined if not found. */
export const getTestingPhaseConfig = (
  agentName: string,
): TestingPhaseAgentConfig | undefined =>
  testingPhaseAgents.find((a) => a.agentName === agentName);
